import { mapKeys } from 'lodash-es'

export const SCRAPING = 'SCRAPING'
export const PROBING = 'PROBING'

export const MENU_CHANGE_DETECTION_METHODS = mapKeys(
  [
    { name: 'Scraping', value: SCRAPING },
    { name: 'Probing', value: PROBING },
  ],
  'value',
)
